import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material';
import { usePageView } from 'src/analytics';
import { MOBILE_MAX_WIDTH } from 'src/assets/static/constants';
import AppMessageListener from 'src/components/AppMessageListener';
import { LoadingScreen } from 'src/components/loading-screen';
import ScrollToTop from 'src/components/scroll-to-top';

// ----------------------------------------------------------------------

export default function SimpleLayout() {
  usePageView();

  return (
    <Container>
      <MainContainer>
        <Outlet />
      </MainContainer>
      <ScrollToTop />
      <LoadingScreen />
      <AppMessageListener />
    </Container>
  );
}

const Container = styled('div')({
  width: '100%',
  height: '100vh',
  margin: 'auto',
  maxWidth: MOBILE_MAX_WIDTH,
});

const MainContainer = styled('main')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
});
